import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-home',
  imports: [CommonModule, RouterModule],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home {
  user = computed(() => this.authService.currentUser());

  constructor(private authService: AuthService) {}

  login(): void {
    this.authService.login();
  }

  loginWithYahoo(): void {
    this.authService.loginWithYahoo();
  }
}
